import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartsModule } from 'ng2-charts-x';
import { ProjectCountChartComponent } from './project-count/project-count-chart.component';
import { ProjectTotalChartComponent } from './project-totals/project-total-chart.component';
import { ProjectTableSummaryComponent } from './project-table/project-table-summary.component';
import { RouterModule } from '@angular/router';
import { PipesModule } from '../pipes/pipes-module.module';
import { AgGridModule } from 'ag-grid-angular';
import { ProjectCellRendererComponent } from '../grid/cell-renderers/project-cell-renderer.component';
import { CompanyCellRendererComponent } from '../grid/cell-renderers/company-cell-renderer.component';
import { CommunicationTimelineComponent } from './communication-timeline/communication-timeline.component';
// import { StartCasePipe } from '../pipes/start-case.pipe';

// import { SharedModule } from '../shared.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ChartsModule,
    PipesModule,
    AgGridModule.withComponents([
      CompanyCellRendererComponent,
      ProjectCellRendererComponent
    ])
  ],
  providers: [
    // StartCasePipe
  ],
  declarations: [
    ProjectCountChartComponent,
    ProjectTotalChartComponent,
    ProjectTableSummaryComponent,
    CommunicationTimelineComponent,
  ],
  exports: [
    ProjectCountChartComponent,
    ProjectTotalChartComponent,
    ProjectTableSummaryComponent,
    CommunicationTimelineComponent
  ]
})
export class BBChartsModule { }



// WEBPACK FOOTER //
// ./client/app/shared/charts/bb-charts.module.ts